<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit pathUrl='/plant' />
    <div class="content">
      <!-- 左 -->
      <div class="left_txts">
        <div class="left_txts_top">
        <div class="left_txts_sub">
          <div class="left_txts_sub_A">
            <div class="subTit1"><span>河南农资供应</span></div>
          </div>
          <div class="left_txts_sub_B">
            <div class="left_txts_sub_d2">
              <div class="left_txts_sub_d2_bt"  :class="{rightBox2_tit_item_cur:state.gyIndex==index+1}" @click="gyClick(index+1)" v-for="(item,index)  in state.gystData1List" :key="index">{{item.name}}</div>

            </div>
            <div class="left_txts_sub_d3" v-if="state.gyIndex==1">
              <dv-scroll-board :config="state.config1"  />
            </div>
            <div class="left_txts_sub_d3" v-else-if="state.gyIndex==2">
              <dv-scroll-board :config="state.config2"  />
            </div>
            <div class="left_txts_sub_d3" v-else>
              <dv-scroll-board :config="state.config3"  />
            </div>
          </div>
        </div>
        <div class="left_txts_sub">
          <div class="left_txts_sub_D">
            <div class="subTit1"><span>供应信息展示</span></div>
            <div class="left2_txts_d2">
              <div class="gyxinx_bt" v-for="(item,index)  in state.gyzsData1List" :key="index">{{item.name}}</div>
            </div>
            <div class="left2_txts_d3">
              <div class="left2_txts_d3_nr" v-for="(item,index)  in state.gyxxData1List" :key="index">
                <div class="nr_img">
                  <img :src="item.img">
                </div>
                <div class="nr_zj">
                  <div class="name1"><span class="xhx">{{item.name}}</span></div>
                  <div class="name1"><span class="xhx1">{{item.txt1}}</span></div>
                  <div class="name1">
                    <span class="d3_txts">已服务:{{item.fw}}次</span>
                    <span class="d3_txts1">浏览:{{item.ll}}次</span>
                  </div>
                </div>
                <div class="nr_yb">
                  <span>{{item.jg}}</span>
                  <span>{{item.zl}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="left_txts_down">
          <div class="subTit1 subTit2"><span >主粮价格趋势图</span></div>
          <div class="left_txts_down_daoh">
            <div class="down_daoh_bt" @click="zlClick(index+1)" :class="{down_daoh_bt_none:state.zlIndex==index+1}" v-for="(item,index)  in state.zlzsData1List" :key="index">{{item.name}} </div>

          </div>
          <div class="left_txts_down_dzst">
            <leftline/>

          </div>
        </div>
      </div>
      <!-- 中 -->
      <div class="middle_txts" ref="mapRef">
        <div class="middle_txts_dh">

          <div class="middle_txts_dh_bt" v-for="(item,index)  in state.dtdhData1List" :key="index" @click="buttonClick(index+1)">
            <img :src="item.img">
            <span>{{item.name}}</span>

          </div>

        </div>



      </div>
      <!-- 右 -->
      <div class="right_txts">
        <div class="right_txts_top">
          <div class="subTit1 subTit2"><span>种植成本</span></div>
          <div class="right_txts_top_nr">
            <div class="top_nr_bt">


              <div class="top_nr_bt_left" v-for="(item,index)  in state.zzcbData1List" :key="index">
                <img :src="item.img">
                <span>{{item.name}}</span>
              </div>

              
            </div>
            <div class="top_nr_wb">
              <RightPie/>

            </div>


          </div>


        </div>
        <div class="right_txts_bottom">
          <div class="right_txts_bottom_left">
            <div class="subTit1"><span>河南农产品批发价格</span></div>
            <div class="pf_txt"> <dv-scroll-board :config="state.rightDatas"  /></div>


          </div>
          <div class="right_txts_bottom_right">
            <div class="subTit1"><span>上蔡小麦指数</span></div>
            <div class="pf_txt"><LeftBar/></div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="footer">本产品由来村网提供技术支持</div>
</template>

<script setup>
// @ is an alias to /src
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Gep from "../utils/范围面.json";
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit.vue";
import RightPie from "@/components/nongyecx/right_pie.vue";
import leftline from "@/components/nongyecx/left_line.vue";
import LeftBar from "../components/nongyecx/LeftBar"
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";


// const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const state = reactive({
  leftData1: [{
    name: "采购热度",
    value: 7510,
    hb: "-21",
    tb: "7",
    icon: require('../assets/img/nyhongshu/cg.png')
  }, {
    name: "交易热度",
    value: 5916,
    hb: "-19",
    tb: "-1",
    icon: require('../assets/img/nyhongshu/jy.png')
  }, { name: "售卖热度", value: 4047, hb: "-27", tb: "3", icon: require('../assets/img/nyhongshu/sm.png') }],
  leftData2: [],
  rightData1List: [
    {
      name: "售卖",
      list: [{ name: '烟薯', value: 25.7 }, { name: '商薯', value: 3.7 }, { name: '蜜薯', value: 12 }, {
        name: '龙薯',
        value: 8.1
      }, { name: '济薯', value: 7.1 }, { name: '其他', value: 24.8 }]
    },
    {
      name: "采购",
      list: [{ name: '烟薯', value: 30 }, { name: '西瓜红', value: 26 }, { name: '蜜薯', value: 8.3 }, {
        name: '龙薯',
        value: 7
      }, { name: '商薯', value: 5.4 }, { name: '其他', value: 23.3 }]
    },
    {
      name: "交易",
      list: [{ name: '烟薯', value: 68.6 }, { name: '商薯', value: 9.9 }, {
        name: '蜜薯',
        value: 9.5
      }, { name: '板栗薯', value: 5.1 }, { name: '黄心红薯', value: 3 }, { name: '其他', value: 9.1 }]
    },
  ],
  gystData1List: [
    {
      name: "供应商",
    },
    {
      name: "投标单位",

    },
    {
      name: "中标单位",

    },
  ],
  gyzsData1List: [
    {
      name: "供应",
    },
    {
      name: "求购",

    },

  ],
  dtdhData1List: [
    {
      name: "蔬菜",
      img:require("../assets/img/nongyecx/4.png"),
    },
    {
      name: "粮食",
      img:require("../assets/img/nongyecx/1.png"),

    },
    {
      name: "农资",
      img:require("../assets/img/nongyecx/3.png"),
    },
    {
      name: "农具",
      img:require("../assets/img/nongyecx/2.png"),

    },

  ],
  zzcbData1List: [
    {
      name: "亩均的成本（1000/亩）",
      img:require("../assets/img/nongyecx/jm.png"),
    },
    {
      name: "土地租赁成本(1000O亩）",
      img:require("../assets/img/nongyecx/jm.png"),

    },


  ],
  zlzsData1List: [
    {
      name: "小麦",
    },
    {
      name: "玉米",

    },
    {
      name: "红薯",

    },
    {
      name: "土豆",

    },
    {
      name: "芝麻",

    },
    {
      name: "花生",

    },
    {
      name: "花生",

    },


  ],
  gyxxData1List: [
    {
      name: "黄姜",
      img:require("../assets/img/pingpai/v1/hj1.jpg"),
      txt1:"长期提供",
      jg:"550元/吨",
      zl:'4000吨',
      fw:'85',
      ll:"333"

    },
    {
      name: "红薯 ",
      img:require("../assets/img/pingpai/v1/hs.png"),
      txt1:"长期提供",
      jg:"550元/吨",
      zl:'4000吨',
      fw:'85',
      ll:"333"

    },
    {
      name: "萝卜",
      img:require("../assets/img/pingpai/v1/lb.png"),
      txt1:"长期提供",
      jg:"550元/吨",
      zl:'4000吨',
      fw:'85',
      ll:"333"

    },
  ],


  config1: {
    data: [
      [ "上蔡县XXX有限公司", "一标段"],
      [ "上蔡县XXX有限公司", "一标段"],
      [ "上蔡县XXX有限公司", "一标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],

    ],
    headerBGC: "",
    oddRowBGC: " #102F2A;",
    evenRowBGC: "",

    index: false,

    // columnWidth: [200],
    align: ["center","center"],
    headerHeight: 90,
    rowNum: 7
  },
  config2: {
    data: [
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],

    ],
    headerBGC: "",
    oddRowBGC: " #102F2A;",
    evenRowBGC: "",

    index: false,
    // columnWidth: [200],
    align: ["center","center"],
    headerHeight: 90,
    rowNum: 7
  },
  config3: {
    data: [
      [ "上蔡县XXX有限公司", "三标段"],
      [ "上蔡县XXX有限公司", "三标段"],
      [ "上蔡县XXX有限公司", "三标段"],
      [ "上蔡县XXX有限公司", "三标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],
      [ "上蔡县XXX有限公司", "二标段"],

    ],
    headerBGC: "",
    oddRowBGC: " #102F2A;",
    evenRowBGC: "",

    index: false,
    // columnWidth: [200],
    align: ["center","center"],
    headerHeight: 90,
    rowNum: 7
  },
  rightDatas: {
    header: [
      '<span style="color:#fff; font-size: 30px;">农产品名称</span>',
      '<span style="color:#fff;font-size: 30px;">批发价格</span>',
      '<span style="color:#fff;font-size: 30px;">周长跌幅度</span>',
    ],
    data: [
      [ "小麦", "1.5","涨"],
      [ "玉米", "1.5","涨"],
      [ "高粱", "1.5","涨"],
      [ "黄姜", "1.5","涨"],
      [ "红薯", "1.5","涨"],
      [ "丝瓜", "1.5","涨"],
      [ "大豆", "1.5","涨"],


    ],
    headerBGC: "",
    oddRowBGC: "",
    evenRowBGC: "",
    index: false,
    // columnWidth: [200],
    align: ["center","center","center"],
    headerHeight: 90,
    rowNum: 4
  },

  startVal: 0,
  xsindex: 0,
  showDiv: true,
  gyIndex:1,
  zlIndex:1,
  animatingMarkerIndex:0
});
const emit = defineEmits(["mapLoad"]);
const boundaryData = Gep;
console.log(boundaryData);

const marker = ref();
const map = ref(null);
let current = ref(0);
// 地图底图
// 第一种
let mapType = ref("vec");
let mapLabelType = ref("cva");
let mapType1 = ref(
  L.tileLayer(
    "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    }
  )
);

let mapLabelType1 = ref(
  L.tileLayer(
    "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    }
  )
);
// 定义一个新的函数，用于触发单个marker的动画效果
function animateSingleMarker(marker, newIconOptions, animationDuration) {
  const originalIcon = marker.options.icon;
  const newIcon = L.icon(newIconOptions);

  // 更改marker的图标
  marker.setIcon(newIcon);

  // 延迟一段时间后恢复原图标
  setTimeout(() => {
    marker.setIcon(originalIcon);
    state.animatingMarkerIndex++;
  }, animationDuration);
}
// 定义一个周期性动画函数
function animateMarkersSequentially(markersList, newIconOptions, intervalBetweenAnimations) {
  // 清除之前的定时器
  clearTimeout(animationTimer);

  // 检查是否有更多marker需要动画化
  if (animatingMarkerIndex < markersList.length) {
    // 获取下一个待动画化的marker
    const nextMarker = markersList[animatingMarkerIndex].marker;

    // 触发单个marker的动画
    animateSingleMarker(nextMarker, newIconOptions, intervalBetweenAnimations);

    // 设置新的定时器以继续动画下一个marker
    animationTimer = setTimeout(() => {
      animateMarkersSequentially(markersList, newIconOptions, intervalBetweenAnimations);
    }, intervalBetweenAnimations);
  }
}

const initMap = () => {
  map.value.addLayer(mapType1.value);
  map.value.addLayer(mapLabelType1.value);
  map.value.on("click", ({ latlng }) => {
    console.log("坐标：", Object.values(latlng));
  });

  return map.value;
};
// 新增一个清除所有标记的方法
function clearMarkers() {
  // 如果map.value存在并且有layers，则遍历删除所有标记
  if (map.value && map.value.eachLayer) {
    map.value.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        map.value.removeLayer(layer);
      }
    });
  }
}
// 假设有个按钮点击事件，用buttonClick表示
function buttonClick(index) {
  // 清除所有已存在的标记
  clearMarkers();

  // 筛选出iconName为"1.png"的标记数据
  const filteredMarkers = markersData.find(
    (markerDatum) => markerDatum.iconName === index + ".png"
  );

  // 遍历筛选出来的标记数据，添加到地图上
  if (filteredMarkers) {
    for (const latlng of filteredMarkers.locations) {
      const iconPath = require(`../assets/img/nongyecx/${filteredMarkers.iconName}`);

      const marker = createAndAddMarker(latlng, {
        title: `地标`,
        icon: L.icon({
          iconUrl: iconPath,
          iconSize: [87, 54],
          iconAnchor: [22, 94],
          popupAnchor: [-3, -76],
        }),
      });

      // 添加自定义的弹出内容
      const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
        filteredMarkers.title ? filteredMarkers.title : "地标"
      }</div>`;
      marker.bindPopup(popupContent);
    }
  }
}

// 定义一个函数用来创建和添加Marker
function createAndAddMarker(latlng, options = {}) {
  const marker = L.marker(latlng, options);
  marker.addTo(map.value);
  return marker;
}
const markersData = [
  {
    locations: [
      [33.24852197238643, 114.13867950439453],
      [33.25225446466308, 114.13816452026369],
      [33.257709358906965, 114.14606094360353],
      [33.265747529651456, 114.16048049926759],
      [33.26804401400031, 114.1747283935547],
      [33.21678935259466, 114.17249679565431],
    ],
    iconName: "1.png",
    // 其他相关属性...
  },
  // ...
  {
    locations: [
      [33.25742226770037, 114.13576126098634],
      [33.264742798760246, 114.14949417114258],
      [33.265891061692386, 114.16254043579103],
      [33.2625897650737, 114.15430068969728],
      [33.2575658134216, 114.15206909179689],
      [33.25656098842019, 114.16786193847658],
    ],
    iconName: "2.png",
    // 其他相关属性...
  },
  // ...
  {
    locations: [
      [33.232298134827396, 114.17490005493165],
      [33.23330323878864, 114.18193817138672],
      [33.232872481362676, 114.18914794921876],
      [33.23962077058048, 114.188289642334],
      [33.242061512882714, 114.18039321899415],
    ],
    iconName: "3.png",
    // 其他相关属性...
  },
  // ...
  {
    locations: [
      [33.24076936368183, 114.20219421386719],
      [33.22856479040233, 114.21009063720705],
      [33.22511848486836, 114.1937828063965],
    ],
    iconName: "4.png",
    // 其他相关属性...
  },


];

function createDashedPolyline(feature, style) {
  const latLngs = feature.geometry.coordinates;
  if (feature.geometry.type === "Polygon") {
    // 取外圈线作为多段线处理
    latLngs = [latLngs[0]];
  } else if (feature.geometry.type === "MultiPolygon") {
    // 处理多个多边形，这里仅取第一个外圈线
    latLngs = [latLngs[0][0]];
  }

  const options = {
    ...style,
    dashArray: [5, 5], // 虚线长度与间距
    lineCap: "round", // 线头样式，可选
    lineJoin: "round", // 线交接处样式，可选
  };

  return L.polyline(latLngs, options);
}
// 添加行政区划边界的逻辑
const loadBoundary = () => {
  L.geoJSON(boundaryData, {
    onEachFeature: function (feature, layer) {
      let style;

      switch (feature.properties.T) {
        case "未建成":
          style = {
            color: "green",
            fillColor: "green",
            fillOpacity: 0.25,
            dashArray: [5, 5],
            weight: 1,
          };
          break;
        case "其他":
          style = {
            color: "green",
            fillColor: "green",
            fillOpacity: 0.25,
            dashArray: [5, 5],
            weight: 1,
          };
          break;
        default:
          style = {
            color: "white",
            fillColor: "red",
            fillOpacity: 0.25,
            dashArray: [5, 5],
            weight: 1,
          };
      }

      if (
        feature.geometry.type === "Polygon" ||
        feature.geometry.type === "MultiPolygon"
      ) {
        // 设置填充样式
        layer.setStyle(style);

        // 处理每个外环线为虚线
        feature.geometry.coordinates.forEach((ring, index) => {
          if (index === 0 || feature.geometry.type === "Polygon") {
            // 对于多边形，只处理外环线
            const dashedLine = createDashedPolyline(
              { geometry: { coordinates: [ring] } },
              style
            );
            map.value.addLayer(dashedLine);
          }
        });
      } else if (
        feature.geometry.type === "LineString" ||
        feature.geometry.type === "MultiLineString"
      ) {
        const dashedLine = createDashedPolyline(feature, style);
        map.value.addLayer(dashedLine);
      }

      // 添加原始图层到地图上（用于显示填充区域）
      map.value.addLayer(layer);
    },
  }).addTo(map.value);
};
//点击切换数据

function gyClick(index){
  state.gyIndex = index
}

function zlClick(index){
  state.zlIndex = index
}
const removeMap = () => {
  if (mapObj.value) {
    mapObj.value.remove();
  }
};
// 定义一个动画队列，依次放大每个marker的视野

const mapObj = ref();
// 在 onMounted 中初始化地图
onMounted(() => {
  map.value = L.map(mapRef.value, {
    center: [33.24859375258743, 114.18210983276369],

    // center: [114.182633, 33.240019],
    zoom: 14,
    minZoom: 3,
    maxZoom: 19,
    noWrap: true,
    // dragging: false,
    zoomControl: true,
    attributionControl: false,
  });
  mapObj.value = initMap();
  // createMarkers();
  loadBoundary();
  for (const markerDatum of markersData) {
    for (const latlng of markerDatum.locations) {
      const iconPath = require(`../assets/img/nongyecx/${markerDatum.iconName}`);

      const marker = createAndAddMarker(latlng, {
        title: `地标`,
        icon: L.icon({
          iconUrl: iconPath,
          iconSize: [87, 54], // 图标大小
          iconAnchor: [32, 94], // 图标锚点
          popupAnchor: [-3, -76], // 弹出窗锚点
        }),
      });

      // 假设没有针对每个点定制的弹出内容，可以根据需求添加
      const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
        markerDatum.title ? markerDatum.title : "地标"
      }</div>`;
      marker.bindPopup(popupContent);
    }
  }


});


onUnmounted(() => {


});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});

</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 30px;
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 10000;
  font-weight: bold;
}

body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep  .dv-scroll-board .rows .row-item{
  font-size: 30px;

}
::v-deep .header{
  //border-bottom:#18CAA6 2px solid ;

}
::v-deep .pf_txt .row-item {
  border-bottom:#18CAA6 2px  dashed;

}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;

  .content {
    width: 100%;
    height: calc(100% - 150px);
    position: absolute;
    top: 150px;
    // border: #fff 1px solid;
    display: flex;
    flex-flow: row;
    padding-bottom: 150px;

    .subTit1 {
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("../assets/img/nyhongshu/bt3.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;


      span {
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }

    .subTit2 {
      height: 195px;
      line-height: 30px;
      background: url("../assets/img/nyhongshu/bt2.png") no-repeat;
      background-size: 100% 100%;

    }

    .subTit_tit {
      display: flex;
      justify-content: space-between;
      position: relative;
      height: 61px;
      line-height: 61px;
      padding: 0 30px 0 30px;

      span:first-child {
        color: #1FE4CC;
        font-size: 26px;
      }

      span:last-child {
        display: flex;
        font-size: 26px;
        color: #fff;
        align-items: center;

        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
        }
      }
    }

    .subTit_tit::before {
      content: "";
      width: 4px;
      height: 21px;
      background: #1FE4CC;
      position: absolute;
      top: 20px;
      left: 10px;
    }

    .left_txts {
      width: 2000px;
      height: 100%;
      margin: 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      //border: #00CBFF 1px solid;
      .left_txts_top{
        width: 100%;
        height: 750px;
        //border: #fff 1px solid;
        display: flex;

      }


      .left_txts_sub {
        width: 1000px;
        height: 100%;
        //border: 1px solid #f00;
        display: flex;
        flex-direction: column;

        .left_txts_sub_A {
          width: 100%;
          height: 130px;


        }

        .left_txts_sub_B {
          width: 100%;
         flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          .left_txts_sub_d2{
            width:92%;
            height: 80px;
            display: flex;
            //border: 1px solid #35FFD2;
            .left_txts_sub_d2_bt{
              height: 80px;
              flex: 1;
              border: 1px solid #35FFD2;
              margin: 0 15px;
              color: #ffffff;
              font-size: 36px;
              line-height: 80px;
              text-align: center;
              cursor: pointer;
              background-color: #102F29;

            }
            .rightBox2_tit_item_cur{
              color: #23FFF2;
            }

          }
          .left_txts_sub_d3{
            width:90%;
            flex: 1;
            margin-top: 20px;
            //border: 1px solid #35FFD2;
            margin-bottom: 20px;

          }


        }

        .left_txts_sub_D {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          .left2_txts_d2{
            width:100%;
            height: 80px;
            display: flex;
            //align-items: center;
            justify-content: center;
            margin-top: -20px ;
            .gyxinx_bt{
              width: 228px;
              height: 100%;
              border: 1px solid #35FFD2;
              margin: 0 15px;
              color: #ffffff;
              font-size: 36px;
              line-height: 80px;
              text-align: center;
              cursor: pointer;
              background-color: #102F29;

            }

          }
          .left2_txts_d3{

            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            .left2_txts_d3_nr{
              width: 100%;
              height: 30%;
              border-bottom: none; /* 首先移除原有的下划线 */
              box-shadow: 0 2px 0 #0D302B, /* 用box-shadow模拟下划线 */
              0 2px 0 rgba(255, 255, 255, 0.5); /* 添加白色发光效果 */
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 1%;
              .nr_img{
                width: 180px;
                height: 140px;
                margin-left: 50px;
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              .nr_zj{
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
                margin-left: 30px;
                align-items: center;
                justify-content: center;
                .name1{
                  flex: 1;
                  width: 100%;
                  color: #23FFF2;
                  text-align: left;
                  font-size: 30px;
                }
                .xhx{
                  display: block;
                  width: 110px;
                  border-bottom: 6px solid #0D302B;
                  line-height: 45px;

                }
                .xhx1{
                  display: block;
                  line-height: 45px;

                }
                .d3_txts{
                  color: #fff;

                }
                .d3_txts1{
                  color: #fff;
                  margin-left: 30px;

                }
              }

              .nr_yb{

                width:300px ;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                  color: #23FFF2;
                  font-size: 34px;
                }
                span:first-child {
                  border-right: 4px solid #0D302B;
                  margin-right: 20px;
                  padding-right: 25px;
                }
              }
            }
          }
        }
      }
      .left_txts_down{
        flex: 1;
        width: 100%;
        //border: #fff 1px solid;
        display: flex;
        flex-direction: column;
        position: relative;
        left: 0;

        .subTit2{
          position: absolute;
          left: 0;
          top: 0;


        }
        .left_txts_down_daoh{
          width: 100%;
          height: 60px;
          display: flex;
          position: absolute;
          top: 120px;


          justify-content: center;
          align-items: center;
          .down_daoh_bt{
            width: 170px;
            height: 60px;
            border: 1px solid #01D4D7;
            color: #fff;
            margin: 0 25px;
            font-size: 28px;
            display: flex;
            justify-content: center;
            align-items: center;

          }
          .down_daoh_bt_none{

            border: none;
          }

          .down_daoh_bt::before  {
            content: " ";
            background: #21FCFF;
            width: 5px;
            height: 31px;
            position: relative;
            top: 0;
            left:-53px;
          }
          .down_daoh_bt::after {
            content: " ";
            background: #21FCFF;
            width: 5px;
            height: 31px;
            position: relative;
            top: 0;
            left: 54px;
          }



        }
        .left_txts_down_dzst{
          width: 100%;
          height: 380px;
          position: relative;
          //border: #00CBFF 1px solid;
          top: 190px;
        }


      }

    }

    .middle_txts {
      flex: 1;
      height: calc(100% - 100px);
      margin: 0 50px;
      padding: 100px 60px;
      margin-top: 100px;
      border: 2px solid #19BBC3;
      .middle_txts_dh{
        width: 280px;
        height: 500px;
        position: absolute;
        right: 0;
        top: 360px;
        display: flex;
        flex-direction: column;
        z-index: 999999;

        .middle_txts_dh_bt{
          width: 100%;
          height: 95px;
          margin: 20px 0;
          //background:#384350;
          background: rgba(56, 67, 80, 0.8);
          font-size: 30px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 72px;
            height: 45px;
            margin-right: 20px;
          }
          span{
            margin-left: 20px;
          }

        }

        .middle_txts_dh_bt:nth-child(3){


          background: rgba(51, 69, 90, 0.8);

        }
        .middle_txts_dh_bt:nth-child(4){


          background: rgba(51, 69, 90, 0.8);

        }




      }
    }
    }


  .echarts {
    width: 100%;
    flex: 1;
  }

  //右
  .right_txts {
    width: 2127px;
    height: 100%;
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    //border: #00CBFF 1px solid;

    .right_txts_top {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      //border: #00CBFF 1px solid;
      .subTit_tit {
        margin-top: -70px;
      }
      .right_txts_top_nr{
        width: 100%;
        height:100%;
        //border: #DE5954 1px solid;
        display: flex;
        flex-direction: column;
        margin-top: -50px;
        .top_nr_bt{
          width: 100%;
          height: 140px;
          display: flex;
          .top_nr_bt_left{
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width: 136px;
              height: 137px;
            }
            span{
              font-size: 42px;
              color: #fff;
              margin-left: 40px;
            }
          }
        }
        .top_nr_wb{
          width: 100%;

          flex: 1;
        }

      }
    }

    .right_txts_bottom {
      width: 100%;
      height: 564px;
      display: flex;

      .right_txts_bottom_left {
        flex: 1;
        height: 100%;
        //border: 1px solid;
        display: flex;
        flex-direction: column;
      }

      .right_txts_bottom_right {
        width: 1022px;
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      .pf_txt{
        width: 100%;
        flex: 1;

      }
    }
  }
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
